import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string | number;
}

const SortableRow: React.FC<SortableRowProps> = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: props['data-row-key'],
    });

    const style = {
        ...props.style,
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <tr {...props} ref={setNodeRef} style={style}>
            {props.children}
        </tr>
    );
};

export default SortableRow;
